// extracted by mini-css-extract-plugin
export default {"tab":"style_tab__QvOWu","text":"style_text__-7tQk","activeText":"style_activeText__K5JqJ"};